var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMailHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "360px",
    height: "56px",
    viewBox: "0 0 360 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Toolbar / Generic (incl more button) Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6,16 C7.1,16 8,16.9 8,18 C8,19.1 7.1,20 6,20 C4.9,20 4,19.1 4,18 C4,16.9 4.9,16 6,16 L6,16 Z M6,14 C4.9,14 4,13.1 4,12 C4,10.9 4.9,10 6,10 C7.1,10 8,10.9 8,12 C8,13.1 7.1,14 6,14 L6,14 Z M6,8 C4.9,8 4,7.1 4,6 C4,4.9 4.9,4 6,4 C7.1,4 8,4.9 8,6 C8,7.1 7.1,8 6,8 L6,8 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,7 L20,18.997 C20,20.103 19.105,21 18.006,21 L5.994,21 C4.893,21 4,20.106 4,18.997 L4,7 L20,7 Z M16,9 L8,9 L8,11 L16,11 L16,9 Z M21,3 L21,6 L3,6 L3,3 L21,3 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,19 C6,20.1 6.9,21 8,21 L16,21 C17.1,21 18,20.1 18,19 L18,7 L6,7 L6,19 Z M15.5,4 L14.5,3 L9.5,3 L8.5,4 L5,4 L5,6 L19,6 L19,4 L15.5,4 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "20 11 7.83 11 13.42 5.41 12 4 4 12 12 20 13.41 18.59 7.83 13 20 13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "[Light]-Card-Samples",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Toolbar-/-Generic-(incl-more-button)-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-Blue",
    fill: "#0078D7"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 360 0 360 56 0 56"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Various-Mono-/-ic_more",
    transform: "translate(332.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    transform: "translate(6.000000, 12.000000) scale(1, -1) translate(-6.000000, -12.000000) ",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-White",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 12 0 12 24 0 24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Mono-/--ic_archive",
    transform: "translate(296.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#8E8E93",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-White",
    mask: "url(#mask-4)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 24 0 24 24 0 24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Mono-/--ic_delete",
    transform: "translate(260.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#8E8E93",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-White",
    mask: "url(#mask-6)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 24 0 24 24 0 24"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Mono-/-ic_back",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Tint-/-Outlook-White",
    mask: "url(#mask-8)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "base",
    points: "0 0 24 0 24 24 0 24"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMailHeader);
export default __webpack_public_path__ + "static/media/mobile_mail_header.5b8d874cdec8b9aa225273e9514247f9.svg";
export { ForwardRef as ReactComponent };